<template>
    <div class="container-addressManagement">
        <div class="title">
            <div class="title-text">
                <img src="../../components/appSidebar/imgs/navigation_icon_goods.png" class="title-logo"/>
                <span>地址管理</span>
            </div>
            <!-- <el-button type="primary" size="small" class="add-button">添加</el-button> -->
        </div>
        <div class="warning"><i class="el-icon-warning-outline"></i>温馨提示：请添加物流地址，最多可添加5条地址</div>
		<el-form ref="form" :model="form" :rules="rules"  label-width="130px">
            <el-form-item label="联系人" prop="receiver">
                <el-input v-model="form.receiver" required="true"
                placeholder="最多可输入15个字"
                width="200px"
                :clearable="true" maxlength="15" show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item label="所在地区" class="region-item"> <!--  prop="regArr" -->
                <span class="required">*</span>
                <el-cascader
                    ref="region"
                    v-model="regArr"
                    :props="props"
                    @change="handleChange"></el-cascader>
                    <p class="zone-required-desc salePrice-error" v-if="regionError">请选择所在地区</p>
            </el-form-item>
			<el-form-item label="街道地址"  prop="detailAddress" class="detail-address">
				<el-input v-model="form.detailAddress" required="true"
					:rows="4"
                    placeholder="请输入详细地址" type="textarea" 
					:clearable="true" maxlength="120" show-word-limit>
                </el-input>
			</el-form-item>
			<el-form-item label="邮政编码" prop="zipcode">
				<el-input v-model="form.zipcode" required="true"
                    type="number"
                    placeholder="请输入邮政编码，6位数字"
					:clearable="true" maxlength="6" show-word-limit>
				</el-input>
			</el-form-item>
            <el-form-item label="手机号码" prop="tel">
				<el-input v-model="form.tel" required="true"
                    type="number" placeholder="请输入手机号，11位数字"
					:clearable="true" maxlength="11" show-word-limit>
				</el-input>
			</el-form-item>
            <el-form-item>
                <div class="button-wrapper">
                    <el-button type="primary" @click="onSubmit" >保存</el-button>
                    <el-button @click="reset">取消</el-button>
                </div>
            </el-form-item>
        </el-form>
		
        <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="skuId"
                label="是否默认"
                width="120">
                <template slot-scope="scope">
                    <el-radio-group v-model="defaultselected" @change="setDefault(scope.row)">
                        <el-radio :label="scope.row.id">&nbsp;&nbsp;</el-radio>
                    </el-radio-group>
					
                </template>
            </el-table-column>
            <el-table-column
                prop="receiver"
                label="联系人"
                width="120">
            </el-table-column>
            <el-table-column
                prop="picUrl"
                label="所在地区">
                <template slot-scope="scope">
                    <span>{{scope.row.provinceName}}/{{scope.row.cityName}}/{{scope.row.countyName}}/{{scope.row.townName}}</span>
                </template>
            </el-table-column>
			<el-table-column
                prop="detailAddress"
                label="街道地址">
				
            </el-table-column>
            <el-table-column
                prop="zipcode"
                label="邮政编码"
                width="90">
            </el-table-column>
            
            <el-table-column
                prop="tel"
                label="手机号码"
                width="120">
            </el-table-column>
            <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <div class="btnline" >
                        <el-button
                            size="mini"
                            type="primary"
                            v-if="scope.row.status == 1"
                            @click="edit(scope.row)">编辑
                        </el-button>
                        <el-button
                            v-if="scope.row.status == 1"
                            size="mini"
                            type="primary"
                            @click="delAction(scope.row)">删除
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
		<el-dialog
        title="提示"
        :visible.sync="dialogDellVisible"
        width="30%">
			<span>确定删除这条地址吗？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogDellVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleDel">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    mounted() {
        this.initList();
	},
    data() {
        let me = this;
        return {
            delId: '',
            defaultselected: 1,
            regionError: false,
            dialogDellVisible: false,
            editing: false,
            props: {
                value: 'id',
                label: 'name',
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(node);
                    const {value} = node;
                    let params = Object.assign({
                        id: value || 'CHN',
                        leafs: true
                    }, {
                        // platformId: 436537610,
                        // merchantId: 0,
                        // operator: 'admin'
                    });
                    // 获取地区列表
                    me.$api.getRegion(params).then(res => {
                        if (+res.code !== 0) {
                            me.$notify({
                                title: '提示',
                                message: res.msg
                            });
                            return;
                        }
                        let list = res.leafs;
                        list.map(item => {
                            item.leaf = !item.has_leaf;
                        });
                        resolve(list);
                    });
                }
            },
            tableData: [
                    /*     {
                    "encodeTel": "18057256028",
                    "townName": "东华门街道",
                    "receiver": "柳叶",
                    "cityId": 110000000000,
                    "townId": 110101001000,
                    "platformId": 436537610,
                    "provinceId": 110000000000,
                    "countryId": "CHN",
                    "zipcode": "100010",
                    "cityName": "北京",
                    "merchantId": 10015,
                    "countyId": 110101000000,
                    "detailAddress": "人民中路1号",
                    "tel": "185****7922",
                    "id": 53,
                    "countryName": "中国",
                    "provinceName": "北京",
                    "selected": 1,
                    "countyName": "东城区",
                    "status": 1
                }, {
                    "encodeTel": "18057260636",
                    "townName": "海淀街道",
                    "receiver": "小叶子",
                    "cityId": 110000000000,
                    "townId": 110108012000,
                    "platformId": 436537610,
                    "provinceId": 110000000000,
                    "countryId": "CHN",
                    "zipcode": "100010",
                    "cityName": "北京",
                    "merchantId": 10015,
                    "countyId": 110108000000,
                    "detailAddress": "西北旺东路10号院",
                    "tel": "185****7936",
                    "id": 48,
                    "countryName": "中国",
                    "provinceName": "北京",
                    "selected": 0,
                    "countyName": "海淀区",
                    "status": 1
                }, {
                    "encodeTel": "18057256028",
                    "townName": "东华门街道",
                    "receiver": "柳叶2",
                    "cityId": 110000000000,
                    "townId": 110101001000,
                    "platformId": 436537610,
                    "provinceId": 110000000000,
                    "countryId": "CHN",
                    "zipcode": "100010",
                    "cityName": "北京",
                    "merchantId": 10015,
                    "countyId": 110101000000,
                    "detailAddress": "人民中路1号",
                    "tel": "185****7922",
                    "id": 54,
                    "countryName": "中国",
                    "provinceName": "北京",
                    "selected": 0,
                    "countyName": "东城区",
                    "status": 1
                } */
            ],
            regArr: [],
            // 校验
            rules: {
                receiver: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                detailAddress: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
                zipcode: [
                    {required: true, message: '请输入邮政编码', trigger: 'blur'}
                ],
                tel: [
                    {required: true, message: '请输入手机号码', trigger: 'blur'}
                ]
            },
            form: {
                id: 0,
                receiver: '',
                provinceId: '',
                provinceName: '',
                countryId: 'CHN',
                countryName: '中国',
                cityId: '',
                cityName: 1,
                countyId: 10,
                countyName: '',
                townId: '',
                townName: '',
                detailAddress: '',
                zipcode: '',
                tel: ''
                // status: '',
                // selected: ''
            },
            regionList:  [
            ],
            regionArr: []
        };
    },
    methods: {
        reset() {
            for (let key in this.form) {
                this.form[key] = '';
            }
            this.form.id = 0;
            this.regionArr = [];
            this.form.countryId = 'CHN';
            this.form.countryName = '中国';
            this.$refs.region.inputValue = '';
        },
        handleChange(value) {
            this.regionError = false;
            this.regArr = value;
        },
        initList(queryid) {
            this.$api.queryAddressInfo().then(res => {
                if (res.code === 0) {
                    this.tableData = res.data;
                    this.tableData.forEach(item => {
                        if (item.selected === 1) {
                            this.defaultselected = item.id;
                        }
                    });
                }
                else {
                    this.$message.error(res.msg);
                }
                this.$nextTick(() => {
                    // document.body.scrollTop(0, 0);
                });
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        edit(data) {
            this.$api.queryAddressInfo({
                id: data.id
            }).then(res => {
                if (res.code === 0) {
                    for (const key in this.form) {
                        this.form[key] = res.data[key];
                    }
                    this.regArr = [this.form.provinceId, this.form.cityId, this.form.countyId, this.form.townId];
                    let regName = [this.form.provinceName, this.form.cityName, this.form.countyName, this.form.townName];
                    this.$refs.region.inputValue = regName.join('/');
                    this.editing = true;
                }
                else {
                    this.$message.error(res.msg);
                }
                this.$nextTick(() => {
                    // document.body.scrollTop(0, 0);
                });
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
            
        },
        delAction(data) {
            this.delId = data.id;
            if (+data.selected === 1) {
                this.$message.error('不能删除默认地址，请先取消默认选项');
                return;
            }
            this.dialogDellVisible = true;
        },
        handleDel() {
            this.$api.delAddress({
                id: this.delId
            }).then(res => {
                // 接口成功做的操作
                
                if (res.code === 0 ) {
                    this.dialogDellVisible = false;
                    this.initList();
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        // 设置默认地址
        setDefault(data) {
            this.defaultselected = data.id;
            this.$api.defaultAddress({
                id: data.id
            }).then(res => {
                // 接口成功做的操作
                if (res.code === 0) {
                    this.$message.success('设置成功');
                    this.initList();
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        onSubmit() {
            let validFlag = true;
            this.$refs.form.validate(valid => {
                if (!valid) {
                    validFlag = false;
                    return false;
                }
            });
            if (!validFlag) {
                return;
            }
            let nodes = this.$refs.region.getCheckedNodes();
            if (!nodes.length) {
                this.regionError = true;
                this.$message.error('请选择所在地区');
                return;
            }
            const nameArr = this.$refs.region.inputValue.split('/');
            this.form.provinceId = this.regArr[0] || '';
            this.form.provinceName = nameArr[0] || '';
            if (this.$refs.region.checkedValue.length === 3) {
                this.form.cityId = this.regArr[0] || ''; 
                this.form.cityName = nameArr[0] || '';
                this.form.countyId	 = this.regArr[1] || '';
                this.form.countyName = nameArr[1] || '';
                this.form.townId = this.regArr[2] || '';
                this.form.townName = nameArr[2] || '';
            }
            else {
                this.form.cityId = this.regArr[1] || ''; 
                this.form.cityName = nameArr[1] || '';
                this.form.countyId	 = this.regArr[2] || '';
                this.form.countyName = nameArr[2] || '';
                this.form.townId = this.regArr[3] || '';
                this.form.townName = nameArr[3] || '';
            }
            if (this.tableData.length >= 5 && !this.editing) {
                this.$message.error('最多可添加5条地址');
                return;
            }
            this.$api.addAddress(this.form).then(res => {
                // 接口成功做的操作
                if (res.code === 0) {
                    this.$message.success('保存成功');
                    this.reset();
                    this.initList();
                }
                else {
                    this.$message.error(res.msg);
                }
                this.editing = false;
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
                this.editing = false;
            });
        }
    }
};
</script>
<style lang="less">
.container-addressManagement {
    .detail-address {
        .el-input__count {
            bottom: -9px;
            background: none;
        }
    }
    .region-item {
        position: relative;
        .required {
            position: absolute;
            // left: -78px;
            color: #F56C6C;
			margin-right: 4px;
			left: -78px;
		}
        .zone-required-desc{
            position: absolute;
            top: 32px;
            color: #F56C6C;
            font-size: 12px;
		}
    }
    
    .el-table_1_column_1 {
        text-align: center !important;
    }
    .el-input, .el-cascader .el-input--suffix {
        width: 500px;
    }
	.el-textarea,
	{
        width: 500px;
    }
    .warning {
        margin: 0 0 20px 54px;
    }
    .el-icon-warning-outline {
        color: #d6d624d1;
    }
	// height: 2000px;
	.query {
		overflow: hidden;
		margin-bottom: 20px;
	}
	.query-key {
		display: inline-block;
		width: 60px;
	}
	.fl {
		float: left;
		margin-right: 40px;
	}
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
        .add-button {
            float: right;
        }
    }
    .detail {
        label {
            display: inline-block;
            width: 100px;
        }
    }
    .standardName {
		display: inline-block;
        width: 80px;
        margin-bottom: 10px;
    }
    .standardTag {
        margin-right: 20px;
        margin-bottom: 10px;
    }
    .standardValue {
        display: inline;
    }
    .standardInfoList {
        margin-bottom: 20px;
    }
    .add-standardName {
        display: inline-block;
        margin-bottom: 6px;
	}
    .dele-color {
        color:#ff5a5f;
    }
    .img-upload-tip {
        color: #606266;
    }
}

.pagation-wrapper {
    background: #ffffff;
    display: flex;
    align-items: center;
    float: right;
    margin: 20px;
    .pagation-text {
        margin-right: 10px;
        font-weight: 400;
        color: #606266;
    }
}

.btnline {
    margin-bottom: 2px;
}
.cl {
    overflow: hidden;
}
.statusview {
    position: relative;
    margin-left: 0px;
    margin-top: 4px;
}
</style>